module.exports = __webpack_public_path__ + "static/media/eliberty1.f2beb404.jpg";